import React from 'react';
import { REPORTS, getLastReportYear } from '../../../files';
import { MAX_COUTRY_LIST_ITEMS } from '../../../helpers';
import './index.scss';
import { getText } from '../../../copies';

const LAST_YEAR = getLastReportYear();

const oldReports = Object.keys(REPORTS)
  .filter((year) => year !== LAST_YEAR.toString())
  .sort((left, right) => parseInt(right, 10) - parseInt(left, 10))
  .map((year) => ({ year, href: REPORTS[year] }));

const Footer = () => (
  <footer className="bg-co-grey-1100 co-grey-100 grid-12">
    <div className="col-12-xs col-7-lg content">
      <h2 className="co-grey-100">{getText('page_footer_title')}</h2>
      <div className="text-container">
        <p>{getText('page_footer_text_1', { citiesCount: MAX_COUTRY_LIST_ITEMS })}</p>
        <p>
          <a target="_blank" rel="noopener noreferrer" href={REPORTS[LAST_YEAR]}>
            {getText('page_last_year_report', { year: LAST_YEAR })}
          </a>
        </p>
        <p>{getText('page_footer_text_2')}</p>
        <p>
          {oldReports.map(({ year, href }) => (
            <div key={year}>
              <a target="_blank" rel="noopener noreferrer" href={href}>
                {getText('page_footer_old_year_report', { year })}
              </a>
            </div>
          ))}
        </p>
      </div>
    </div>
    <div className="col-12-xs col-5-lg impact-report-img" />
  </footer>
);

export default Footer;
